import { css } from "@emotion/css";
import { isMobile } from "react-device-detect";

interface Props {
	dotList: number[];
	gameType: number;
	size?: number;
	dotListAdjustment?: any;
}

const dotSicbo = [
	require("assets/images/dot-1.png"),
	require("assets/images/dot-2.png"),
	require("assets/images/dot-3.png"),
	require("assets/images/dot-4.png"),
	require("assets/images/dot-5.png"),
	require("assets/images/dot-6.png"),
];

export default function DotLayout(props: Props) {
	const { dotList, gameType, size, dotListAdjustment } = props;

	//game sicbo
	if (gameType === 5) {
		return (
			<div className={`${styles.wrapDot} ${isMobile && "wrapDotMobile"}`}>
				<div className="innerWrapDot">
					{dotList.map((dot, index) => (
						<div style={size ? { width: `${size}px`, height: `${size}px` } : {}} className={styles.dotItem} key={index}>
							{dotSicbo[dot - 1] && <img className="dot-icon" src={dotSicbo[dot - 1]} alt="" />}
						</div>
					))}
					{dotListAdjustment && <span className="lineCenter"></span>}
				</div>
				{dotListAdjustment && (
					<div className="innerWrapDot">
						{dotListAdjustment.result.map((dot: number, index: number) => (
							<div style={size ? { width: `${size}px`, height: `${size}px` } : {}} className={styles.dotItem} key={index}>
								{dotSicbo[dot - 1] && <img className="dot-icon" src={dotSicbo[dot - 1]} alt="" />}
							</div>
						))}
					</div>
				)}
			</div>
		);
	}

	//game xocdia
	return (
		<div className={`${styles.wrapDot} ${isMobile && "wrapDotMobile"}`}>
			<div className="innerWrapDot">
				{dotList.map((dot, index) => (
					<div style={size ? { width: `${size}px`, height: `${size}px` } : {}} className={styles.dotItem} key={index}>
						{dot === 1 && <img className="dot-icon" src={require("assets/images/dot-white.png")} alt="" />}
						{dot === 0 && <img className="dot-icon" src={require("assets/images/dot-red.png")} alt="" />}
					</div>
				))}
				{dotListAdjustment && <span className="lineCenter"></span>}
			</div>
			{dotListAdjustment && (
				<div className="innerWrapDot">
					{dotListAdjustment.result.map((dot: number, index: number) => (
						<div style={size ? { width: `${size}px`, height: `${size}px` } : {}} className={styles.dotItem} key={index}>
							{dot === 1 && <img className="dot-icon" src={require("assets/images/dot-white.png")} alt="" />}
							{dot === 0 && <img className="dot-icon" src={require("assets/images/dot-red.png")} alt="" />}
						</div>
					))}
				</div>
			)}
		</div>
	);
}

const styles = {
	wrapDot: css`
		&.wrapDotMobile {
			display: flex;
			gap: 8px;
			.innerWrapDot {
				margin-bottom: 0;
			}
			.lineCenter {
				width: 100%;
			}
		}
		.innerWrapDot {
			display: flex;
			gap: 4px;
			justify-content: center;
			user-select: none;
			position: relative;
			margin-bottom: 5px;
			&:last-child {
				margin-bottom: 0;
			}
		}
		.lineCenter {
			position: absolute;
			top: 50%;
			left: 50%;
			width: 80%;
			height: 2px;
			margin-top: -1px;
			background: #000;
			transform: translateX(-50%);
		}
	`,
	dotItem: css`
		width: 18px;
		height: 18px;
		border-radius: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		.dot-icon {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	`,
};
